import { useState } from 'react';
import type { Faq } from '@/types/content';

interface FaqAccordionProps {
  items: Faq[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="flex flex-col divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.question}>
            <h3>
              <button
                type="button"
                onClick={() => toggle(index)}
                aria-expanded={isOpen}
                className="flex w-full cursor-pointer items-center justify-between gap-4 py-5 text-left transition-colors hover:text-primary-700"
              >
                <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {item.question}
                </span>
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-colors ${
                    isOpen
                      ? 'border-primary-500 bg-primary-500 text-background-50'
                      : 'border-background-300 text-foreground-600'
                  }`}
                >
                  <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="-mt-1 pb-5 pr-10">
                <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}